<template>
  <Page>
    <div class="container container--tiny">
      <AuthRegisterForm />
    </div>
  </Page>
</template>
<script setup>
const authStore = useAuthStore()
const router = useRouter()
const { $lang } = useNuxtApp()

if (authStore.loggedIn) {
  router.push({ name: `${$lang}-account` })
}
await useI18n(['auth', 'account', 'register'])
useHead({
  title: $t('register/welcome-message')
})
</script>
